function initAnimateFadeIn(container = document) {
  container.querySelectorAll('[use-animate-fade-in]:not([animate-initialized])').forEach(el => {
    el.setAttribute('animate-initialized', 'true');
    const animateDirection = el.dataset.animateDirection || 'left';
    if (animateDirection === 'fade') {
      return;
    }
    const shouldStaggerFade = animateDirection === 'fade' && el.dataset.animateStagger === 'true';
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealChildren = (animateDirection === 'up' || shouldStaggerFade)
      ? Array.from(el.children).flatMap(child => child.classList && child.classList.contains('theme-icon-text-layout') ? Array.from(child.children) : [child])
      : [];

    if (prefersReducedMotion) {
      el.style.opacity = 1;
      el.style.transform = 'none';
      revealChildren.forEach(child => {
        child.style.opacity = 1;
        child.style.transform = 'none';
      });
      return;
    }

    if (shouldStaggerFade && revealChildren.length) {
      el.style.opacity = 1;
      el.style.transform = 'none';
      revealChildren.forEach(child => {
        child.style.opacity = 0;
        child.style.transform = 'none';
        child.style.willChange = 'opacity';
      });
    } else if (animateDirection === 'fade') {
      el.style.opacity = 0;
      el.style.transform = 'none';
      el.style.willChange = 'opacity';
    } else if (animateDirection === 'up' && revealChildren.length) {
      el.style.opacity = 1;
      el.style.transform = 'none';
      revealChildren.forEach(child => {
        child.style.opacity = 0;
        child.style.transform = 'translateY(44px)';
        child.style.willChange = 'opacity, transform';
      });
    } else if (animateDirection === 'up') {
      el.style.opacity = 0;
      el.style.transform = 'translateY(44px)';
      el.style.willChange = 'opacity, transform';
    } else {
      el.style.opacity = 0;
      el.style.transform = 'translateX(-20px)';
      el.style.willChange = 'opacity, transform';
    }

    const playAnimation = () => {
      if (shouldStaggerFade && revealChildren.length) {
        Motion.animate(
          revealChildren,
          { opacity: [0, 1] },
          {
            delay: Motion.stagger(0.24),
            duration: 1.45,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
          }
        ).finished.then(() => {
          revealChildren.forEach(child => {
            child.style.willChange = '';
          });
        });
      } else if (animateDirection === 'fade') {
        Motion.animate(
          el,
          { opacity: [0, 1] },
          { duration: 1.05, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
        ).finished.then(() => {
          el.style.willChange = '';
        });
      } else if (animateDirection === 'up' && revealChildren.length) {
        Motion.animate(
          revealChildren,
          { opacity: [0, 1], y: ['44px', '0'] },
          {
            delay: Motion.stagger(0.11),
            duration: 0.95,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
          }
        ).finished.then(() => {
          revealChildren.forEach(child => {
            child.style.willChange = '';
          });
        });
      } else if (animateDirection === 'up') {
        Motion.animate(
          el,
          { opacity: [0, 1], y: ['44px', '0'] },
          { duration: 0.95, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
        ).finished.then(() => {
          el.style.willChange = '';
        });
      } else {
        Motion.animate(
          el,
          { opacity: [0, 1], x: ['-20px', '0'] },
          { duration: 0.6, easing: 'ease-out' }
        ).finished.then(() => {
          el.style.willChange = '';
        });
      }
    };

    // 先检查元素是否已经在视口�?解决主题编辑器热更新后元素消失问�?
    const rect = el.getBoundingClientRect();
    const isInViewport = rect.top < window.innerHeight + 50 && rect.bottom > -50;

    if (isInViewport) {
      // 如果元素已经在视口中,直接执行动画显示
      playAnimation();
    } else {
      // 不在视口�?等待进入视口时触�?
      const stopAnimate = Motion.inView(el, (info) => {
        stopAnimate();
        playAnimation();
      }, { margin: '-50px', once: true });
    }
  });
}

const hotScrollRevealState = {
  items: [],
  observer: null
};

function getHotFadeChildren(el) {
  if (el.dataset.animateStagger !== 'true') return [el];
  return Array.from(el.children).flatMap(child => {
    return child.classList && child.classList.contains('theme-icon-text-layout')
      ? Array.from(child.children)
      : [child];
  });
}

function getHotRevealSiblingIndex(el) {
  if (!el.parentElement) return 0;
  return Array.from(el.parentElement.children).indexOf(el);
}

function addHotRevealItem(el, index = 0) {
  if (!el || hotScrollRevealState.items.some(item => item.el === el)) return;
  el.setAttribute('data-hot-scroll-reveal-item', 'true');
  el.style.setProperty('--hot-scroll-opacity', '0');
  el.style.setProperty('--hot-scroll-y', '56px');
  el.style.setProperty('--hot-scroll-delay', Math.min(index, 8) * 130 + 'ms');
  el.style.opacity = 'var(--hot-scroll-opacity)';
  el.style.transform = 'translate3d(0, var(--hot-scroll-y), 0)';
  el.style.transition = 'opacity 1600ms cubic-bezier(0.19, 1, 0.22, 1) var(--hot-scroll-delay), transform 1800ms cubic-bezier(0.19, 1, 0.22, 1) var(--hot-scroll-delay)';
  el.style.willChange = 'opacity, transform';
  hotScrollRevealState.items.push({ el, index });
}

function revealHotScrollItem(el) {
  el.setAttribute('data-hot-scroll-revealed', 'true');
  el.style.setProperty('--hot-scroll-opacity', '1');
  el.style.setProperty('--hot-scroll-y', '0px');
  window.setTimeout(() => {
    if (!document.documentElement.contains(el)) return;
    el.style.willChange = '';
  }, 2100);
}

function getHotScrollRevealObserver() {
  if (hotScrollRevealState.observer || !('IntersectionObserver' in window)) {
    return hotScrollRevealState.observer;
  }

  hotScrollRevealState.observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      revealHotScrollItem(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.16,
    rootMargin: '0px 0px -24% 0px'
  });

  return hotScrollRevealState.observer;
}

function initHotPageReveals(container = document) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selector = [
    '[use-animate-fade-in][data-animate-direction="fade"]:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .section-heading__wrapper:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] [data-hot-reveal-item]:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .data-card:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .trust-badge__item:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .collapsible-content__item:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .subscribe-box:not([data-hot-scroll-initialized])',
    '[data-hot-section-reveal] .countdown-box:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .section-heading__wrapper:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s1__main-text:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .feature-item:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s2__media:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s2__tab-list .tab-item:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s3__block:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s3__bottom-text:not([data-hot-scroll-initialized])',
    '.jxs-hot-reveal .banner-s4__data-grid-item:not([data-hot-scroll-initialized])'
  ].join(',');

  const candidates = [
    ...(container.matches && container.matches(selector) ? [container] : []),
    ...container.querySelectorAll(selector)
  ];
  if (!candidates.length) return;

  candidates.forEach((candidate) => {
    candidate.setAttribute('data-hot-scroll-initialized', 'true');
    const targets = candidate.matches('[use-animate-fade-in][data-animate-direction="fade"]')
      ? getHotFadeChildren(candidate)
      : [candidate];

    targets.forEach((target, index) => {
      const revealIndex = candidate.matches('[use-animate-fade-in][data-animate-direction="fade"]')
        ? index
        : getHotRevealSiblingIndex(target);
      if (prefersReducedMotion) {
        target.style.opacity = 1;
        target.style.transform = 'none';
        target.style.removeProperty('--hot-scroll-y');
        target.style.transition = 'none';
        target.style.willChange = '';
        return;
      }
      addHotRevealItem(target, revealIndex);
      const rect = target.getBoundingClientRect();
      const isReady = rect.top < (window.innerHeight || document.documentElement.clientHeight || 800) * 0.72 && rect.bottom > 0;
      if (isReady) {
        revealHotScrollItem(target);
        return;
      }
      const observer = getHotScrollRevealObserver();
      observer ? observer.observe(target) : revealHotScrollItem(target);
    });
  });
}

function initAnchorSmoothScroll(container = document) {
  container.querySelectorAll('a.anchor-smooth-scroll:not([scroll-initialized]), .template-hot a[href="#pulse-waitlist"]:not([scroll-initialized])').forEach(a => {
    a.setAttribute('scroll-initialized', 'true');
    a.addEventListener('click', e => {
      const link = e.target.closest('a.anchor-smooth-scroll, .template-hot a[href="#pulse-waitlist"]');
      if (!link) return;

      const id = link.getAttribute('href').slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: id === 'pulse-waitlist' ? 'center' : 'start' });
      if (id === 'pulse-waitlist') {
        window.setTimeout(() => {
          const input = target.querySelector('input[type="email"]');
          if (input) input.focus({ preventScroll: true });
        }, 550);
      }
      // 可选：更新 URL hash 但不触发跳转
      history.pushState(null, '', '#' + id);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAnimateFadeIn();
  initHotPageReveals();
  initAnchorSmoothScroll();
});

// 监听 Shopify 主题编辑器的 section 加载事件(热更新后重新初始�?
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      initAnimateFadeIn(event.target);
      initHotPageReveals(event.target);
      initUahpetSectionReveals(event.target);
      initAnchorSmoothScroll(event.target);
    }
  });
}

// 使用 MutationObserver 监听动态添加的元素(兼容各种动态渲染场�?
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          initAnimateFadeIn(node);
          initHotPageReveals(node);
          initUahpetSectionReveals(node);
          initAnchorSmoothScroll(node);
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function initEventSummary(wrapper) {
  wrapper.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
}

initEventSummary(document);

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
    return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia(wrapper = document, includeProductModel = true) {
  wrapper.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  wrapper.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  wrapper.querySelectorAll('video:not(.video--background)').forEach((video) => video.pause());
  if(includeProductModel) {
    wrapper.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}

function updateProductMediaStatus(wrapper) {
  wrapper.querySelectorAll('.product__media img').forEach(e => {
    if(e.complete) {
      addLoadedImageStatus(e);
    } else {
      e.onload = () => {
        addLoadedImageStatus(e);
      };
    }
  });
}

function addLoadedImageStatus(image) {
  const parentElement = image.parentElement;
  if(!parentElement.classList.contains('loaded')) {
    parentElement.classList.add('loaded');
    if(parentElement.nextElementSibling) {
      setTimeout(() => parentElement.nextElementSibling.remove(), 500);
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function loadColorSwatches() {
  window.loadedBackgroundColorSwatches = true;
  fetch(window.Shopify.routes.root + `?section_id=background-color-swatches`)
  .then(res => res.text())
  .then((html) => {
    document.body.appendChild(getDomHtmlFromText(html, 'style'));
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json', method = 'POST') {
  return {
    method: method,
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function parseHtml(text) {
  return new DOMParser().parseFromString(text, 'text/html');
}

function getDomHtmlFromText(text, selector) {
  return parseHtml(text)
      .querySelector(selector);
}

function getInnerHtmlFromText(text, selector) {
  return getDomHtmlFromText(text, selector).innerHTML;
}

function closeDetailsInAnimation(detailsElement) {
  let animationStart;

  const handleAnimation = (time) => {
    if (animationStart === undefined) {
      animationStart = time;
    }

    const elapsedTime = time - animationStart;

    if (elapsedTime < 400) {
      window.requestAnimationFrame(handleAnimation);
    } else {
      detailsElement.removeAttribute('open');
      if (detailsElement.closest('details[open]')) {
        trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
      }
    }
  }

  window.requestAnimationFrame(handleAnimation);
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(t, e) {
  function n(t, e) {
    return void 0 === t ? e : t
  }

  function o(t, e, o, i) {
    if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
    var r = (t = (t / 100).toFixed(e)).split(".");
    return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var i = "",
      r = /\{\{\s*(\w+)\s*\}\}/,
      a = e || moneyFormat;
  switch (a.match(r)[1]) {
    case "amount":
        i = o(t, 2);
        break;
    case "amount_no_decimals":
        i = o(t, 0);
        break;
    case "amount_with_comma_separator":
        i = o(t, 2, ".", ",");
        break;
    case "amount_with_space_separator":
        i = o(t, 2, " ", ",");
        break;
    case "amount_with_period_and_space_separator":
        i = o(t, 2, " ", ".");
        break;
    case "amount_no_decimals_with_comma_separator":
        i = o(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        i = o(t, 0, " ");
        break;
    case "amount_with_apostrophe_separator":
        i = o(t, 2, "'", ".")
  }
  return a.replace(r, i)
}

Shopify.showPrice = function(price, noConvert = false) {
  return (!noConvert) ? Shopify.formatMoney(price * Shopify.currency.rate) : Shopify.formatMoney(price);
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    HTMLUpdateUtility.reinjectsScripts(element);
  }

  static reinjectsScripts(element) {
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class JxsTopLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 注意:appendChild 到新父节点会再次触发 connectedCallback,所以用父节点判�?而不是实例标记�?
    // 同时在主题编辑器里每次修改设置都会重新渲�?section,产生一个新�?<jxs-top-link> 实例,
    // 因此不能依赖实例属�?必须在每次连接时清理 header 区域内的"�?元素�?
    const target = document.querySelector('sticky-header .header__icons');
    if (!target) return;

    // 如果当前已经在目标容器里,说明是本次移动后触发的重�?不再处理
    if (this.parentNode === target) return;

    // 等待 DOM 就绪后再移动,防止 header 尚未渲染
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.moveToHeader(target));
    } else {
      this.moveToHeader(target);
    }
  }

  moveToHeader(target) {
    // 清理 header 里所有旧�?jxs-top-link(主题编辑器重新渲染时旧实例还残留�?header �?
    target.querySelectorAll('jxs-top-link').forEach((el) => {
      if (el !== this) el.remove();
    });

    // 如果设置�?hide-nav-icon,给目标容器加上标记类,通过 CSS 在桌面端隐藏原本图标
    if (this.hasAttribute('hide-nav-icon')) {
      target.classList.add('header__icons--hide-original');
    } else {
      target.classList.remove('header__icons--hide-original');
    }

    // 将自身追加到 header__icons 区域末尾
    target.appendChild(this);

    // 移动完成,标记�?ready,让默认的隐藏样式失效,显示出来
    this.setAttribute('ready', '');
  }

  disconnectedCallback() {
    // �?section 在主题编辑器中被删除/重新渲染,原始位置的元素会被移除�?
    // 但被搬到 header 里的元素不会触发,此处仅做兜底:若移除时本身就在 header �?
    // 则同步清�?hide-nav-icon 样式标记,防止图标一直被隐藏�?
    const target = document.querySelector('sticky-header .header__icons');
    if (target && !target.querySelector('jxs-top-link[hide-nav-icon]')) {
      target.classList.remove('header__icons--hide-original');
    }
  }
}
customElements.define('jxs-top-link', JxsTopLink);

// 主题编辑�?�?jxs-top-link section 被删除时,清理掉残留在 header 里的元素
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail.sectionId;
    document.querySelectorAll(`jxs-top-link[data-section-id="${sectionId}"]`).forEach((el) => {
      el.remove();
    });
    const target = document.querySelector('sticky-header .header__icons');
    if (target && !target.querySelector('jxs-top-link[hide-nav-icon]')) {
      target.classList.remove('header__icons--hide-original');
    }
  });
}

class DrawerFixed extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close(evt));
    this.stickyHeader = document.querySelector('sticky-header');
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : (this.classList.contains('drawer--cart') ? document.getElementById('CartDrawer') : document.getElementById('QuickAddDrawer'));
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('open-drawer-fixed');
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return getInnerHtmlFromText(html, selector);
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return getDomHtmlFromText(html, selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  close(evt) {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('open-drawer-fixed');
    setTimeout(() => {
      document.body.dispatchEvent(new CustomEvent('drawerClosed'));
    }, 500);
  }
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.removeAttribute('hidden');
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.classList.add('closing');
    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
      this.classList.remove('closing');
    }, 600);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.dataset.modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class RichCountdownTimer extends HTMLElement {
  constructor() {
    super();

    Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
  }

  get date() {
    return this._date = this._date || new Date(this.getAttribute('data-expires'));
  }

  get isCompact() {
    return this.getAttribute('data-compact') === 'true' || (this.getAttribute('data-compact') === 'mobile' && theme.config.mqlSmall);
  }

  get timerList() {
    return this.querySelector('.countdown__timer-list')
  }

  get completedMessage() {
    return this.querySelector('.countdown__timer-message')
  }

  /**
   * @param {*} unit d | h | m | s
   */
  getTimeText(unit) {
    let text
    switch (unit) {
      case 'd':
        text = 'dy'
        break
      case 'h':
        text = 'hr'
        break
      case 'm':
        text = 'min'
        break
      case 's':
        text = 'sec'
        break
    }
    return text
  }

  createSplitItem() {
    const split = document.createElement('div')
    split.textContent = ':'
    split.classList.add('countdown__split')
    this.timerList.appendChild(split)
    return split
  }

  createCountdownItem(unit) {
    const countdownItem = document.createElement('div')
    countdownItem.classList.add('countdown__item', 'time-' + unit)
    const p = document.createElement('p')
    p.textContent = '--'
    countdownItem.appendChild(p)
    const span = document.createElement('span')
    span.textContent = this.getTimeText(unit)
    countdownItem.appendChild(span)
    this.timerList.appendChild(countdownItem)
    return {
      item: countdownItem,
      time: p,
      unit: span
    }
  }

  init() {

    this.daysElement = this.createCountdownItem('d')
    this.daysElement.split = this.createSplitItem()
    this.hoursElement = this.createCountdownItem('h')
    this.hoursElement.split = this.createSplitItem()
    this.minsElement = this.createCountdownItem('m')
    this.minsElement.split = this.createSplitItem()
    this.secsElement = this.createCountdownItem('s')

    this.calculate();
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  calculate() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.complete();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

    this.daysElement.time.textContent = (days + '').padStart(2, '0')
    this.daysElement.unit.textContent = this.getTimeText('d', days > 1)
    if (days < 1) {
      this.daysElement.item.classList.add('hidden-important')
      this.daysElement.split.classList.add('hidden-important')
    } else {
      this.daysElement.item.classList.remove('hidden-important')
      this.daysElement.split.classList.remove('hidden-important')
    }

    this.hoursElement.time.textContent = (hours + '').padStart(2, '0')
    this.hoursElement.unit.textContent = this.getTimeText('h', hours > 1)

    this.minsElement.time.textContent = (mins + '').padStart(2, '0')
    this.minsElement.unit.textContent = this.getTimeText('m', mins > 1)

    this.secsElement.time.textContent = (secs + '').padStart(2, '0')
    this.secsElement.unit.textContent = this.getTimeText('s', secs > 1)
  }

  complete() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.setAttribute('completed', '')
  }
}
customElements.define('rich-countdown-timer', RichCountdownTimer);

class ControlVideo extends HTMLElement {
  constructor() {
    super()
    this._onPlayListener = this.onPlay.bind(this)
    this._onPauseListener = this.onPause.bind(this)
    this._onPosterListener = this.onPosterClick.bind(this)
    if (this.hasAttribute('autoplay-inview')) {
      Motion.inView(this, () => {
        this.play()
        if (this.hasAttribute('autopause')) {
          return () => {
            this.pause()
          }
        }
      })
    }
  }

  get video() {
    return this.querySelector('video')
  }

  get poster() {
    return this.querySelector('.control-video__poster')
  }

  connectedCallback() {
    this.poster?.addEventListener('click', this._onPosterListener)
    this.video?.addEventListener('play', this._onPlayListener)
    this.video?.addEventListener('pause', this._onPauseListener)
    if (this.video && this.video.controls != true) {
      this.setAttribute('no-controls', '')
    }
  }

  disconnectedCallback() {
    this.poster?.removeEventListener('click', this._onPosterListener)
    this.video?.removeEventListener('play', this._onPlayListener)
    this.video?.removeEventListener('pause', this._onPauseListener)
  }

  onPosterClick() {
    if (this.video) {
      if (this.video.paused) {
        this.video.play()
      } else {
        this.video.pause();
      }
    }
  }

  play() {
    this.video?.play()
  }

  pause() {
    this.video?.pause()
  }

  onPlay() {
    this.setAttribute('playing', '')
  }

  onPause() {
    this.removeAttribute('playing')
  }
}
customElements.define('control-video', ControlVideo);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = (this.dataset.outsidePrevButtonId != undefined ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsidePrevButtonId}`) : this.querySelector('button[name="previous"]'));
    this.nextButton = (this.dataset.outsideNextButtonId != undefined ? this.closest('[id^="shopify-section"]').querySelector(`#${this.dataset.outsideNextButtonId}`) : this.querySelector('button[name="next"]'));
    this.isAutoplay = this.slider.dataset.autoplay === 'true';
    this.autoplayButtonQuerySelector = '.slider__autoplay';
    this.autoPlayPausedClass = 'slider__autoplay--paused';
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.slider) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');

    this.initPages();

    if(this.nextButton) {
      this.onButtonClickHandler = this.onButtonClick.bind(this);
      this.prevButton.addEventListener('click', this.onButtonClickHandler);
      this.nextButton.addEventListener('click', this.onButtonClickHandler);
    }

    if (this.isAutoplay) this.setAutoPlay();

    if(this.sliderControlButtons) {
      this.sliderControlLinksArray = Array.from(this.sliderControlButtons);
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    window.addEventListener('resize', debounce((event) => {
      this.initPages();
    }), true);

    this.slider.addEventListener('scroll', this.update.bind(this));
  }

  disconnectedCallback() {
    if(this.nextButton) {
      this.prevButton.removeEventListener('click', this.onButtonClickHandler);
      this.nextButton.removeEventListener('click', this.onButtonClickHandler);
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    const slidersPerPageInFloat = this.slider.clientWidth / Math.abs(this.sliderItemOffset);
    this.slidesPerPage = Math.ceil(slidersPerPageInFloat);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.sliderControlButtons.length) {
      const limit = this.sliderItemsToShow.length - this.slidesPerPage;
      this.sliderControlButtons.forEach((link, indexLink) => {
        link.classList.remove('hidden');
        if(indexLink > limit) {
          link.classList.add('hidden');
        }
      });
    }
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage && this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    if (this.isAutoplay && this.autoplayButtonIsSetToPlay) this.play();

    if (this.enableSliderLooping || !this.nextButton) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft < 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth - 1) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(this.autoplayButtonQuerySelector);
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    if(this.sliderAutoplayButton) {
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    }

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  linkToSlide(event) {
    event.preventDefault();
    this.goToSlideByTarget(event.currentTarget);
  }

  goToSlideByTarget(target) {
    const slideScrollPosition = this.slider.scrollLeft + this.sliderItemOffset * (this.sliderControlLinksArray.indexOf(target) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  autoPlayToggle() {
    this.togglePlayButtonState();
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearTimeout(this.autoplay);
    this.autoplay = setTimeout(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearTimeout(this.autoplay);
  }

  togglePlayButtonState() {
    if(!this.sliderAutoplayButton) return;
    if (!this.autoplayButtonIsSetToPlay) {
      this.sliderAutoplayButton.classList.add(this.autoPlayPausedClass);
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove(this.autoPlayPausedClass);
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.totalPages ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.sectionId = this.dataset.originalSection || this.dataset.section;
  }

  onVariantChange(event) {
    const target = this.getInputForEventTarget(event.target);
    this.publishChangeEvent(target);
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    const valueIds = [];
    this.querySelectorAll('select').forEach((select) => {
      valueIds.push(select.options[select.selectedIndex].dataset.optionValueId);
    });
    return valueIds;
  }

  publishChangeEvent(target, recall = false, customSelectedOptionValues = null) {
    const params = {
      sectionId: this.dataset.section,
      target: target,
      selectedOptionValues: (customSelectedOptionValues) ? customSelectedOptionValues : this.selectedOptionValues,
    };
    if(recall) {
      params.recallId = this.dataset.section;
    }
    document.dispatchEvent(new CustomEvent('optionValueSelectionChange', {detail: params}));
  }

  isHidden(element) {
    if (element) {
      if (element.tagName  === 'INPUT') {
        return element.parentElement.classList.contains('hidden')
      } else {
        return element.classList.contains('hidden')
      }
    } else {
      return true
    }
  }

  /**
   * 当产品选项改变时，如果当前已选中的选项是隐藏状态，就换成其他非隐藏的选项�?
   * 这是应对某些产品选项是隐藏的（无库存时隐藏），但是用户已经选择了该选项的场景�?
   */
  autoCorrectNotHiddenVariant() {
    const newSelectedOptions = [];
    this.querySelectorAll('.product-form__input--variant-picker').forEach(fieldset => {
      const checkedOption = fieldset.querySelector('li input[type="radio"]:checked, option[selected]');
      if (this.isHidden(checkedOption)) {
        const notHiddenOption = fieldset.querySelector('li:not(.hidden) input[type="radio"], option:not(.hidden)');
        if (notHiddenOption) {
          newSelectedOptions.push({target: notHiddenOption, checked: false})
        } else {
          newSelectedOptions.push({target: null, checked: false})
        }
      } else {
        newSelectedOptions.push({target: checkedOption, checked: true})
      }
    })
    const newSelectedOptionValues = [];
    let checkedCount = 0
    for (const opt of newSelectedOptions) {
      if (opt.target == null) {
        return
      }
      if (opt.checked) checkedCount++
      newSelectedOptionValues.push(opt.target.dataset.optionValueId);
    }
    if (checkedCount === newSelectedOptions.length) {
      return;
    }
    const lastedOptionValueId = newSelectedOptions[newSelectedOptions.length - 1].target.id
    this.publishChangeEvent(document.getElementById(lastedOptionValueId), true, newSelectedOptionValues);
  }

  autoCorrectAvailableVariant(newProductInfoNode) {
    const newSelectedOptionValues = [];
    var findSelectedOptionValue;
    var stopFinding = false;
    newProductInfoNode.querySelectorAll('.product-form__input--variant-picker').forEach(fieldset => {
      if(stopFinding == false) {
        if(!fieldset.classList.contains('last')) {
          const currentSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:checked, option:not(.hidden)[selected]');
          if(currentSelectedOptionValue) {
             newSelectedOptionValues.push(currentSelectedOptionValue.dataset.optionValueId);
          } else {
            const altCurrentSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"], option:not(.hidden)');
            newSelectedOptionValues.push(altCurrentSelectedOptionValue.dataset.optionValueId);
            stopFinding = true;
          }
        } else {
          findSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:not(:checked), option:not(.hidden):not([selected])');
          if(!findSelectedOptionValue) {
            findSelectedOptionValue = fieldset.querySelector('li:not(.hidden) input[type="radio"]:checked, option:not(.hidden)[selected]');
          }
          newSelectedOptionValues.push(findSelectedOptionValue.dataset.optionValueId);
        }
      } else {
        const currentSelectedOptionValue = fieldset.querySelector('li input[type="radio"]:checked, option[selected]');
        newSelectedOptionValues.push(currentSelectedOptionValue.dataset.optionValueId);
        if(fieldset.classList.contains('last')) {
          findSelectedOptionValue = currentSelectedOptionValue;
        }
      }
    });
    this.publishChangeEvent(document.getElementById(findSelectedOptionValue.id), true, newSelectedOptionValues);
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadBackgroundColorSwatches();
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('input[type="radio"]:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  loadBackgroundColorSwatches() {
    if(!window.loadedBackgroundColorSwatches && this.querySelectorAll('.product-form__input__radio-label--color').length > 0) {
      loadColorSwatches();
    }
  }
}

customElements.define('variant-radios', VariantRadios);

const deferredMediaObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if(entry.isIntersecting) {
      entry.target.loadContent(false);
    } else {
      entry.target.pause();
    }
  });
});

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if(this.dataset.ignore) {
      return;
    }
    this.isPlaying = false;
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    if(this.dataset.autoplay) {
      deferredMediaObserver.observe(this);
    }
  }

  loadContent(focus = true, play = false) {
    if (!this.deferredElement) {
      if(!this.hasAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', true);
        this.deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      } else {
        this.deferredElement = this.querySelector('video, model-viewer, iframe');
      }
    }
    if(this.deferredElement) {
      if (focus) this.deferredElement.focus();
      if (this.deferredElement.getAttribute('autoplay') || this.dataset.autoplay || play) {
        // force autoplay for safari
        this.play();
      }
    }
  }

  play() {
    if(this.isPlaying) return;
    if(this.deferredElement.nodeName == 'VIDEO') {
      this.deferredElement.play();
    } else if(this.deferredElement.classList.contains('js-youtube')) {
      this.deferredElement.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    } else if(this.deferredElement.classList.contains('js-vimeo')) {
      this.deferredElement.contentWindow.postMessage('{"method":"play"}', '*');
    }
    this.isPlaying = true;
  }

  pause() {
    if(this.deferredElement && this.isPlaying) {
      window.pauseAllMedia(this);
      this.isPlaying = false;
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class BtStorageUtil {
  static set(key, value, isSession) {
    if (isSession) {
      sessionStorage.setItem(
        `bt-${key}`,
        typeof value === 'object' ? JSON.stringify(value) : value
      );
    } else {
      localStorage.setItem(`bt-${key}`, typeof value === 'object' ? JSON.stringify(value) : value);
    }
  }

  static get(key, isJson, isSession) {
    const value = isSession ? sessionStorage.getItem(`bt-${key}`) : localStorage.getItem(`bt-${key}`);
    if (isJson) {
      return JSON.parse(value);
    }
    return value;
  }

  static remove(key, isSession) {
    if (isSession) {
      sessionStorage.removeItem(`bt-${key}`);
    } else {
      localStorage.removeItem(`bt-${key}`);
    }
  }
}


class ProductTabComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.querySelectorAll('.tab-item').forEach(tabItem => {
      tabItem.addEventListener('click', this.onTabItemClick.bind(this))
    })
    this.setupWindowResizeEvent()
    // 需要等待一会儿，不然sticky-header.calculateHeaderHeight()无法执行
    setTimeout(() => {
      this.initTop()
    }, 1000)
  }

  initTop() {
    const header = document.querySelector('sticky-header')
    if (header && header.calculateHeaderHeight) {
      this.querySelector('.tab-nav').style.top = header.calculateHeaderHeight() + 'px'
    } else {
      const navHeight = document.querySelector('header.header').clientHeight
      this.querySelector('.tab-nav').style.top = navHeight + 'px'
    }
  }

  setupWindowResizeEvent() {
    this.debouncedOnWindowResize = debounce((event) => {
      this.onWindowResize(event);
    }, 500);

    window.addEventListener('resize', this.debouncedOnWindowResize, false);
  }

  onWindowResize () {
    this.initTop()
  }

  onTabItemClick(event) {
    event.preventDefault()

    this.clearActive()
    const currentTabId = event.target.dataset.tab
    event.target.classList.add('active')
    const tabContent = this.querySelector(`.content-item[data-tab="${currentTabId}"]`)
    tabContent.classList.add('active')

    const container = this.closest('.product-tab-sticky-background')
    container.classList.remove.apply(container.classList, Array.from(container.classList).filter(v=>v.startsWith('bbb-')));
    container.classList.add('bbb-' + currentTabId)
  }

  clearActive() {
    this.querySelectorAll('.tab-item').forEach(tabItem => {
      tabItem.classList.remove('active')
    })
    this.querySelectorAll('.content-item').forEach(tabItem => {
      tabItem.classList.remove('active')
    })
  }
}
customElements.define('product-tab-component', ProductTabComponent)


class SplideSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const options = {
      gap: '10px',
      perPage: 5,
      perMove: 1,
      pagination: false,
      arrows: true
    }
    if (this.dataset.type) options.type = this.dataset.type
    if (this.dataset.role) options.role = this.dataset.role
    if (this.dataset.label) options.label = this.dataset.label
    if (this.dataset.gap) options.gap = this.dataset.gap
    if (this.dataset.perPage) options.perPage = parseInt(this.dataset.perPage)
    if (this.dataset.perMove) options.perMove = parseInt(this.dataset.perMove)
    if (this.dataset.pagination) options.pagination = this.dataset.pagination === 'true'
    if (this.dataset.padding) {
      if (this.dataset.padding.includes('{')) {
        options.padding = JSON.parse(this.dataset.padding)
      } else {
        options.padding = this.dataset.padding
      }
    }
    if (this.dataset.arrows) options.arrows = this.dataset.arrows === 'true'
    if (this.dataset.mediaQuery) options.mediaQuery = this.dataset.mediaQuery
    if (this.dataset.destroy) options.destroy = this.dataset.destroy === 'true' ? true : this.dataset.destroy
    if (this.dataset.breakpoints) options.breakpoints = JSON.parse(this.dataset.breakpoints)

    new Splide(this, options).mount();
  }
}

customElements.define('splide-slider', SplideSlider)


class SimpleVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.video = this.querySelector('video')
    if (this.video.getAttribute('controls') === 'controls') {
      this.insertPlayButton()
      this.video.addEventListener('play', () => {
        this.classList.add('playing')
      })
      this.video.addEventListener('pause', () => {
        this.classList.remove('playing')
      })
    }
  }

  insertPlayButton () {
    const button = document.createElement('div')
    button.classList.add('play-button')
    this.appendChild(button)

    const icon = document.createElement('span')
    icon.classList.add('play-icon')
    button.appendChild(icon)

    button.addEventListener('click', () => {
      this.video.play()
    })

    return button
  }
}
customElements.define('simple-video', SimpleVideo)

class ProductDetailRecommendations extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    new Splide(this.querySelector('.splide'), {
      perPage: 2,
      gap: 20,
      pagination: false,
      arrows: this.querySelectorAll('.splide__slide').length > 2
    }).mount()
  }
}
customElements.define('product-detail-recommendations', ProductDetailRecommendations)


class SlideshowImageProgress extends HTMLElement {
  constructor() {
    super();
    this._currentTime = 0;
    this._duration = parseInt(this.dataset.duration || '5000'); // 默认5�?
    this._isPlaying = false;
    this._animationId = null;
    this._lastTime = 0;
  }

  get currentTime() {
    return this._currentTime / 1000;
  }

  set currentTime(value) {
    this._currentTime = value * 1000;
    // 重置时间戳避免计算跳�?
    this._lastTime = performance.now();
  }

  get duration() {
    return this._duration / 1000;
  }

  connectedCallback() {
    // 确保元素可以接收事件监听
    if (!this.style.display || this.style.display === 'inline') {
      this.style.display = 'block';
    }
  }

  disconnectedCallback() {
    this.pause();
  }

  play() {
    if (this._isPlaying) return;
    this._isPlaying = true;
    this._lastTime = performance.now();
    this._animate();
  }

  pause() {
    this._isPlaying = false;
    if (this._animationId) {
      cancelAnimationFrame(this._animationId);
      this._animationId = null;
    }
  }

  _animate() {
    if (!this._isPlaying) return;

    const now = performance.now();
    const delta = now - this._lastTime;
    this._lastTime = now;

    this._currentTime += delta;

    // 模拟结束
    if (this._currentTime >= this._duration) {
      this._currentTime = 0;
      // 触发 ended 事件
      this.dispatchEvent(new CustomEvent('ended', {
        bubbles: true,
        cancelable: false
      }));
    }

    // 发�?timeupdate 事件，模�?video 的行�?
    this.dispatchEvent(new CustomEvent('timeupdate', {
      bubbles: true,
      cancelable: false
    }));

    this._animationId = requestAnimationFrame(this._animate.bind(this));
  }
}
customElements.define('slideshow-image-progress', SlideshowImageProgress);

class JxsSlideshowVideo extends HTMLElement {
  constructor() {
    super()
    this.autoNext = this.hasAttribute('auto-next')
    this.mobileQuery = window.matchMedia('(max-width: 767px)')
    this.mobileQuery.addEventListener('change', this.onViewportSizeChanged.bind(this))
    this.init()
    Motion.inView(this, () => {
      this.onVideoStartPlay();
    })
  }

  init() {
    this.splide = new Splide(this.querySelector('.splide'), {
      perPage: 1,
      arrows: false,
      pagination: false
    })
    this.splide.on('active', this.onSlideActive.bind(this))
    this.splide.mount()

    const onVideoProgressChangedListener = this.onVideoProgressChanged.bind(this)
    const onVideoEndedListener = this.onVideoEnded.bind(this)
    this.querySelectorAll('.video-wrapper video, slideshow-image-progress').forEach(v => {
      v.addEventListener('timeupdate', onVideoProgressChangedListener)
      if (this.autoNext) {
        v.addEventListener('ended', onVideoEndedListener)
      }
    })

    // 自动播放下一张时，禁用视频循�?
    if (this.autoNext) {
      this.querySelectorAll('.video-wrapper video').forEach(v => {
        v.loop = false
      })
    }

    const onPaginationItemClickListener = this.onPaginationItemClick.bind(this)
    this.querySelectorAll('.pagination .page-item').forEach(item => {
      item.addEventListener('click', onPaginationItemClickListener)
    })
  }

  getVideoByMediaQuery(videoWrapper) {
    const image = videoWrapper.querySelector('slideshow-image-progress')
    if (image) {
      return image
    }
    if (this.mobileQuery.matches) {
      return videoWrapper.querySelector('video.video-mobile') ||
             videoWrapper.querySelector('video.video-desktop')
    } else {
      return videoWrapper.querySelector('video.video-desktop')
    }
  }

  stopAllVideo() {
    this.querySelectorAll('.video-wrapper video, slideshow-image-progress').forEach(v => {
      v.pause()
    })
  }

  replayVideo(video) {
    if (video) {
      video.currentTime = 0
      video.play()
    }
  }

  playNext() {
    if (this.splide.index + 1 == this.splide.Components.Elements.slides.length) {
      this.splide.go(0)
    } else {
      this.splide.go('>')
    }
  }

  onViewportSizeChanged() {
    this.stopAllVideo()
    const slide = this.splide.Components.Elements.slides[this.splide.index]
    const vw = slide.querySelector('.video-wrapper')
    const video = this.getVideoByMediaQuery(vw)
    this.replayVideo(video)
  }

  onVideoStartPlay() {
    const slideEl = this.splide.Components.Elements.slides[0]
    if (slideEl) {
      const vw = slideEl.querySelector('.video-wrapper')
      this.getVideoByMediaQuery(vw)?.play()
    }
  }

  onSlideActive(slideComp) {
    this.currentProgress = this.querySelector(`.pagination .page-item[data-index="${this.splide.index + 1}"] .progress`)
    this.stopAllVideo()
    this.querySelectorAll('.pagination .progress').forEach(item => {
      item.style.setProperty('--percent', '0%')
    })
    const video = this.getVideoByMediaQuery(slideComp.slide.querySelector('.video-wrapper'))
    if (video) {
      this.replayVideo(video)
    } else {
      setTimeout(() => {
        this.currentProgress.style.setProperty('--percent', '100%')
      })
    }
  }

  onVideoProgressChanged(e) {
    if (this.currentProgress) {
      const video = e.target
      const progress = (video.currentTime / video.duration) * 100
      this.currentProgress.style.setProperty('--percent', progress + '%')
    }
  }

  onVideoEnded() {
    if (this.autoNext) {
      this.playNext()
    }
  }

  onPaginationItemClick(e) {
    const index = parseInt(e.target.closest('.page-item').dataset.index)
    this.splide.go(index - 1)
  }
}
customElements.define('jxs-slideshow-video', JxsSlideshowVideo);

/**
 * @author jxs
 */
class CardSlider extends HTMLElement {
  constructor() {
    super()
    this.initSplide()
  }

  initSplide() {

    this.prevArrows = Array.from(this.closest('.shopify-section').querySelectorAll('.card-slider__arrow.arrow-left'))
    this.nextArrows = Array.from(this.closest('.shopify-section').querySelectorAll('.card-slider__arrow.arrow-right'))

    const goPrevListener = this.goPrev.bind(this)
    this.prevArrows.forEach(arrow => {
      arrow.addEventListener('click', goPrevListener)
    })
    const goNextListener = this.goNext.bind(this)
    this.nextArrows.forEach(arrow => {
      arrow.addEventListener('click', goNextListener)
    })

    this.splide = new Splide(this.querySelector('.splide'), {
      type: this.dataset.loop == 'true' ? 'loop' : 'slide',
      autoplay: this.dataset.autoplay == 'true',
      interval: parseInt(this.dataset.autoplaySec) * 1000,
      pagination: true,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        0: {
          perPage: parseInt(this.dataset.columnsSm),
          gap: parseInt(this.dataset.mobileGap),
          padding: {
            right: parseInt(this.dataset.mobileRightPadding)
          },
          destroy: this.dataset.mobileEnabled == 'false'
        },
        768: {
          perPage: parseInt(this.dataset.columnsMd),
          gap: parseInt(this.dataset.desktopGap),
          padding: {
            right: parseInt(this.dataset.desktopRightPadding)
          },
          destroy: this.dataset.desktopEnabled == 'false'
        },
        1200: {
          perPage: parseInt(this.dataset.columnsLg),
          destroy: this.dataset.desktopEnabled == 'false'
        }
      }
    })
    this.splide.on('ready', this.onSliderReady.bind(this))
		this.splide.on('move', this.onSliderMove.bind(this))
    this.splide.mount()

  }

  onSliderReady() {
    this.updateArrowStates()
  }

  onSliderMove() {
    this.updateArrowStates()

    // 给splide设置padding-right时，滑到最后一个会出现留白
    // 使用is-end标记，让css那边可以处理这个留白
    if (this.dataset.loop != 'true') {
      const endIndex = this.splide.Components.Controller.getEnd();
      const index = this.splide.Components.Controller.getIndex();
      this.setAttribute('is-end', endIndex == index)
    }
  }

  updateArrowStates() {
    const isLoop = this.splide.options.type == 'loop'
		// 处理上一个箭头状�?
		const isStart = this.splide.index <= 0;
		const prevDisabled = isStart && !this.splide.options.rewind && !isLoop;
		this.prevArrows?.forEach(item => {
      if (prevDisabled) {
        item.setAttribute('disabled', '')
      } else {
        item.removeAttribute('disabled')
      }
    })
		
		// 处理下一个箭头状�?
		const isEnd = this.splide.index >= this.splide.Components.Controller.getEnd();
		const nextDisabled = isEnd && !this.splide.options.rewind && !isLoop;
		this.nextArrows?.forEach(item => {
      if (nextDisabled) {
        item.setAttribute('disabled', '')
      } else {
        item.removeAttribute('disabled')
      }
    })
  }

  goNext() {
    this.splide.go('>')
  }

  goPrev() {
    this.splide.go('<')
  }
}
customElements.define('card-slider', CardSlider);

class SliderCardGroup4 extends HTMLElement {
  constructor() {
    super()

    // 由于嵌套block的原因，无法在liquid里设置第一个元素selected
    this.querySelector('.splide__slide')?.classList.add('selected')
    this.classList.add('js-init')

    this.items = Array.from(this.querySelectorAll('.splide__slide'))

    const onItemActivedListener = this.onItemActived.bind(this)
    this.items.forEach(item => {
      item.addEventListener('click', onItemActivedListener)
      item.addEventListener('mouseenter', onItemActivedListener)
    })
  }

  onItemActived(e) {
    this.items.forEach(item => (item.classList.remove('selected')))
    const item = e.target.closest('.splide__slide')
    item.classList.add('selected')
  }
}
customElements.define('slider-card-group-4', SliderCardGroup4);

class AutoplayVideo extends HTMLElement {
  constructor() {
    super()

    Motion.inView(this, (element) => {
      this.video?.play()
    })
  }

  get video() {
    return this.querySelector('video')
  }
}
customElements.define('autoplay-video', AutoplayVideo);

class BannerWithSlidecard extends HTMLElement {
  // ========== 可配置参�?==========
  // 初始位置：第一张卡片在右侧只露出的像素�?
  static INITIAL_REVEAL = 80
  
  // 卡片之间的间距（像素�?
  static CARD_GAP = 10
  // ================================

  constructor() {
    super()
    this.style.setProperty('--progress-percent', '0%')
    
    this.cardList = this.querySelector('.card-list')
    this.cardItems = this.querySelectorAll('.card-item')
    this.cardContainer = this.querySelector('.banner-with-slidecard__cards')
    
    if (this.cardList && this.cardItems.length > 0) {
      this.initDrag()
    }
  }

  initDrag() {
    this.isDragging = false
    this.startX = 0
    this.startY = 0  // 记录起始Y坐标用于方向判断
    this.currentX = 0
    this.translateX = 0
    this.minX = 0
    this.maxX = 0
    this.cardWidth = 0
    this.totalWidth = 0
    this.containerWidth = 0
    this.gap = BannerWithSlidecard.CARD_GAP
    this.initialReveal = BannerWithSlidecard.INITIAL_REVEAL
    this.dragDirection = null  // 拖拽方向�?horizontal' | 'vertical' | null
    
    this.calculateBounds()
    this.setTranslate(this.maxX)
    this.updateProgress()
    
    // 绑定事件 - 整个卡片容器区域都可以拖�?
    this.boundTouchStart = this.onTouchStart.bind(this)
    this.boundTouchMove = this.onTouchMove.bind(this)
    this.boundTouchEnd = this.onTouchEnd.bind(this)
    this.boundMouseDown = this.onMouseDown.bind(this)
    this.boundMouseMove = this.onMouseMove.bind(this)
    this.boundMouseUp = this.onMouseUp.bind(this)
    this.boundResize = this.onResize.bind(this)
    
    this.cardContainer.addEventListener('touchstart', this.boundTouchStart, { passive: true })
    this.cardContainer.addEventListener('touchmove', this.boundTouchMove, { passive: false })
    this.cardContainer.addEventListener('touchend', this.boundTouchEnd)
    
    this.cardContainer.addEventListener('mousedown', this.boundMouseDown)
    window.addEventListener('mousemove', this.boundMouseMove)
    window.addEventListener('mouseup', this.boundMouseUp)
    
    // 窗口大小变化时重新计算边�?
    window.addEventListener('resize', this.boundResize)
  }

  calculateBounds() {
    if (this.cardItems.length === 0) return
    
    const firstCard = this.cardItems[0]
    this.cardWidth = firstCard.offsetWidth
    
    // 容器宽度
    this.containerWidth = this.cardContainer.offsetWidth
    
    // 总宽度：所有卡�?+ 间距
    this.totalWidth = this.cardItems.length * this.cardWidth + (this.cardItems.length - 1) * this.gap
    
    // 最大X（最右）：初始位置，卡片在最右边，只露出 INITIAL_REVEAL px
    // 第一张卡片左边缘 = translateX
    // 我们希望：containerWidth - translateX = INITIAL_REVEAL（视口内可见宽度�?
    // 所�?translateX = containerWidth - INITIAL_REVEAL
    this.maxX = this.containerWidth - this.initialReveal
    
    // 最小X（最左）：最后一张卡片左边缘不溢出容器左边缘
    // 最后一张卡片左边缘 = translateX + totalWidth - cardWidth
    // 要求：translateX + totalWidth - cardWidth <= 0
    // translateX <= -(totalWidth - cardWidth)
    this.minX = -(this.totalWidth - this.cardWidth)
  }

  setTranslate(x) {
    // 边界检�?
    this.translateX = Math.max(this.minX, Math.min(this.maxX, x))
    this.cardList.style.transform = `translate3d(${this.translateX}px, 0, 0)`
    this.updateProgress()
  }

  updateProgress() {
    // 计算进度百分比：以最后一�?完全在视口内"的卡片为�?
    // 每张卡片的右边缘位置 = translateX + (index + 1) * cardWidth + index * gap
    // 找最后一个满足：右边�?<= containerWidth 的卡�?
    let lastVisibleIndex = 0
    for (let i = 0; i < this.cardItems.length; i++) {
      const cardRight = this.translateX + (i + 1) * this.cardWidth + i * this.gap
      if (cardRight <= this.containerWidth) {
        lastVisibleIndex = i + 1
      } else {
        break
      }
    }
    
    const progress = (lastVisibleIndex / this.cardItems.length) * 100
    this.style.setProperty('--progress-percent', `${progress}%`)
  }

  onTouchStart(e) {
    // 记录起始触摸位置，用于判断拖拽方�?
    this.startX = e.touches[0].clientX
    this.startY = e.touches[0].clientY
    this.currentX = this.translateX
    this.dragDirection = null
    this.isDragging = true
  }

  onTouchMove(e) {
    if (!this.isDragging) return
    
    const touchX = e.touches[0].clientX
    const touchY = e.touches[0].clientY
    const deltaX = touchX - this.startX
    const deltaY = touchY - this.startY
    
    // 如果还没确定方向，判断是水平还是垂直拖拽
    if (this.dragDirection === null) {
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      
      // 移动距离超过一定阈值才判断方向，避免误�?
      if (Math.max(absX, absY) > 5) {
        if (absX > absY) {
          // 水平拖拽：阻止默认滚动，处理卡片滑动
          this.dragDirection = 'horizontal'
        } else {
          // 垂直拖拽：不阻止默认滚动，也不处理卡�?
          this.dragDirection = 'vertical'
          this.isDragging = false
          return
        }
      } else {
        // 移动距离太小，暂时不做处�?
        return
      }
    }
    
    // 只有水平拖拽才处理卡片滑�?
    if (this.dragDirection === 'horizontal') {
      e.preventDefault()
      this.setTranslate(this.currentX + deltaX)
    }
  }

  onTouchEnd() {
    this.isDragging = false
  }

  onMouseDown(e) {
    e.preventDefault()
    this.isDragging = true
    this.startX = e.clientX
    this.currentX = this.translateX
  }

  onMouseMove(e) {
    if (!this.isDragging) return
    
    const deltaX = e.clientX - this.startX
    this.setTranslate(this.currentX + deltaX)
  }

  onMouseUp() {
    this.isDragging = false
  }

  onResize() {
    this.calculateBounds()
    this.setTranslate(this.translateX)
  }

  disconnectedCallback() {
    window.removeEventListener('mousemove', this.boundMouseMove)
    window.removeEventListener('mouseup', this.boundMouseUp)
    window.removeEventListener('resize', this.boundResize)
  }
}
customElements.define('banner-with-slidecard', BannerWithSlidecard);

class ThemeText extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const useAnimate = this.hasAttribute('underline-animate')
    if (!useAnimate) return;

    const stopAnimate = Motion.inView(this, (info) => {
      stopAnimate()
      this.querySelector('.icon-underline path')?.classList.add('svg-path-animate')
    }, { margin: '-50px' });
  }
}
customElements.define('theme-text', ThemeText);


class BannerScroller extends HTMLElement {
  constructor() {
    super()
    // 每个step停留的时�?
    this.durationPerStep = 300
    // 最后一个step停留的时�?
    this.durationLastStep = this.durationPerStep * 0.6
    this.init()
  }

  init() {
    this.stepTotal = parseInt(this.getAttribute('item-size'))
    const allDuration = (this.stepTotal - 1) * this.durationPerStep + this.durationLastStep
    // 计算每个步骤的进度区�?
    this.stepThresholds = this.calculateStepThresholds();

    ScrollTrigger.create({
      trigger: this,
      pin: true,
      start: "top top",
      end: "+=" + allDuration,
      scrub: 0.5,
      onUpdate: (self) => {
        const progress = self.progress;
        const currentIndex = this.getCurrentStepIndex(progress);
        this.updateActiveStep(currentIndex);
      }
    });

    this.updateActiveStep(0)
  }

  // 计算每个步骤的进度阈�?
  calculateStepThresholds() {
    const thresholds = [];
    const totalDuration = (this.stepTotal - 1) * this.durationPerStep + this.durationLastStep;

    // 第一个是一开始就显示的，所以给的时间最低，让它快速通过
    thresholds.push(0.1);

    // 前n-1个步�?
    for (let i = 1; i < this.stepTotal - 1; i++) {
      thresholds.push((i + 1) * this.durationPerStep / totalDuration);
    }

    // 最后一个步骤的阈值是1.0
    thresholds.push(1.0);
    return thresholds;
  }

  // 根据progress获取当前步骤index
  getCurrentStepIndex(progress) {
    // 确保progress在[0,1]范围�?
    progress = Math.max(0, Math.min(progress, 1));
    
    for (let i = 0; i < this.stepThresholds.length; i++) {
      if (progress < this.stepThresholds[i]) {
        return i;
      }
    }
    return this.stepTotal - 1; // 默认返回最后一�?
  }

  // 根据index获取对应的progress�?
  getProgressByIndex(index) {
    index = Math.max(0, Math.min(index, this.stepTotal - 1));
    
    // 第一个步骤的progress�?
    if (index === 0) return 0;
    
    // 最后一个步骤的progress�?
    if (index === this.stepTotal - 1) return 1;
    
    // 中间步骤的progress是对应的阈值减去半个区�?
    // 这样可以确保滚动到步骤的中间位置
    const prevThreshold = index * this.durationPerStep / 
                         ((this.stepTotal - 1) * this.durationPerStep + this.durationLastStep);
    const nextThreshold = (index + 1) * this.durationPerStep / 
                         ((this.stepTotal - 1) * this.durationPerStep + this.durationLastStep);
    
    return (prevThreshold + nextThreshold) / 2;
  }

  // index - base on zero
  updateActiveStep(index) {
    this.querySelector('.banner-scroller__content-text-block[active]')?.removeAttribute('active')
    this.querySelector(`.banner-scroller__content-text-block:nth-child(${index + 1})`)?.setAttribute('active', '')

    this.querySelector('.banner-scroller__content-image-block[active]')?.removeAttribute('active')
    this.querySelector(`.banner-scroller__content-image-block:nth-child(${index + 1})`)?.setAttribute('active', '')
  }
}
customElements.define('banner-scroller', BannerScroller);

class ProductDetailSlider extends HTMLElement {

  #splideInstance = null;

  constructor() {
    super()
  }

  get splideList() {
    return this.querySelector('.splide__list')
  }

  connectedCallback() {
    const count = this.findAndBuildItems()
    if (count === 0) {
      return
    }
    let desktopConfig = {
      destroy: true,
      padding: { right: 0 }
    }
    if (this.dataset.slideDesktop == 'true') {
      desktopConfig = {
        perPage: parseInt(this.dataset.slideColumn),
        padding: { right: '20%' }
      }
    }
    this.#splideInstance = new Splide(this, {
      pagination: false,
      arrows: false,
      gap: 10,
      mediaQuery: 'min',
      breakpoints: {
        0: {
          perPage: parseInt(this.dataset.slideColumn),
          padding: {
            right: '20%'
          }
        },
        768: desktopConfig
      }
    })
    this.#splideInstance.mount()
  }

  disconnectedCallback() {
    this.#splideInstance.destroy(true)
  }

  findAndBuildItems() {
    const splideList = this.splideList
    let nextElement = this
    const arr = []
    while (true) {
      nextElement = nextElement.nextElementSibling
      if (nextElement && nextElement.classList.contains('product-detail-slider__item')) {
        nextElement.style.setProperty('--video-ratio', this.dataset.ratio)
        arr.push(nextElement)
      } else {
        break
      }
    }
    arr.forEach(item => {
      splideList.appendChild(item)
    })
    return arr.length
  }
}
customElements.define('product-detail-slider', ProductDetailSlider);

class SubscribeCountdownSection extends HTMLElement {
  constructor() {
    super()
    this.isSubmitting = false
    this.submitResetTimer = null
    this.klaviyoRevision = '2025-10-15'
  }

  connectedCallback() {
    this.form = this.querySelector('form')
    this.submitButton = this.querySelector('button[type="submit"]')
    this.buttonLabel = this.submitButton ? this.submitButton.querySelector('span') : null
    this.originalButtonLabel = this.buttonLabel ? this.buttonLabel.textContent : ''

    if (this.form) {
      this.form.addEventListener('submit', this.handleFormSubmit.bind(this))
    }

    window.addEventListener('pageshow', this.resetSubmitState.bind(this))

    this.initRelatedPulseFormSubmitState()
    this.clearLegacySuccessRedirect()
    this.handleNativeShopifySubscribeCheckoutRedirect()
    this.initTooltip()
  }

  initRelatedPulseFormSubmitState(attempt = 0) {
    const bottomForm = document.querySelector('#subscribe-with-image')
    if (!bottomForm) {
      if (attempt < 40) {
        window.setTimeout(() => this.initRelatedPulseFormSubmitState(attempt + 1), 100)
      }
      return
    }
    if (bottomForm.dataset.pulseSubmitInitialized === 'true') return
    bottomForm.dataset.pulseSubmitInitialized = 'true'
    bottomForm.addEventListener('submit', event => this.handleKlaviyoFormSubmit(event, bottomForm))
  }

  clearLegacySuccessRedirect() {
    const url = new URL(window.location.href)
    const submittedForm = url.searchParams.get('pulse_waitlist')
    if (submittedForm !== 'hero' && submittedForm !== 'bottom') return
    url.searchParams.delete('pulse_waitlist')
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`)
  }

  initTooltip() {
    this.progressStepItems = this.querySelectorAll('.progress-step__item')
    const isHoverDevice = window.matchMedia('(hover: hover)').matches

    this.progressStepItems.forEach(item => {
      const tooltip = item.querySelector('.progress-step__item-tooltip')
      if (!tooltip) return

      // 桌面端（支持hover）：hover时调整边缘位�?
      if (isHoverDevice) {
        item.addEventListener('mouseenter', () => this.adjustTooltipPosition(item, tooltip))
      } else {
        // 移动端：点击切换
        item.addEventListener('click', (e) => {
          e.stopPropagation()
          const isActive = item.classList.contains('tooltip-active')
          this.progressStepItems.forEach(it => it.classList.remove('tooltip-active'))
          if (!isActive) {
            this.adjustTooltipPosition(item, tooltip)
            item.classList.add('tooltip-active')
          }
        })
      }
    })

    if (!isHoverDevice) {
      // 点击空白处关�?
      document.addEventListener('click', () => {
        this.progressStepItems.forEach(it => it.classList.remove('tooltip-active'))
      })
    }

    // 窗口尺寸变化时，重新计算当前激活tooltip的位�?
    window.addEventListener('resize', debounce(() => {
      this.progressStepItems.forEach(it => {
        it.style.removeProperty('--tooltip-shift')
      })
    }, 200))
  }

  adjustTooltipPosition(item, tooltip) {
    // 不能直接使用 tooltip.getBoundingClientRect()，因�?transform 是动画过渡的�?
    // �?transition 过程中读取到的位置可能受上次 shift 的影响�?
    // 改为根据 item 中心�?+ tooltip offsetWidth（布局宽度，不受transform影响）来计算自然位置
    const itemRect = item.getBoundingClientRect()
    const itemCenter = itemRect.left + itemRect.width / 2
    const tooltipWidth = tooltip.offsetWidth
    const naturalLeft = itemCenter - tooltipWidth / 2
    const naturalRight = itemCenter + tooltipWidth / 2

    const viewportWidth = window.innerWidth
    const padding = 10
    let shift = 0

    if (naturalLeft < padding) {
      shift = padding - naturalLeft
    } else if (naturalRight > viewportWidth - padding) {
      shift = (viewportWidth - padding) - naturalRight
    }

    item.style.setProperty('--tooltip-shift', shift + 'px')
  }

  handleFormSubmit(event) {
    if (this.form && this.form.dataset.klaviyoForm) {
      this.handleKlaviyoFormSubmit(event, this.form)
      return
    }

    // 浏览器原生校验失败时（input type=email + required），浏览器会阻止submit触发
    // 因此进入这里说明已经通过了HTML原生校验

    if (this.isSubmitting) {
      event.preventDefault()
      return
    }

    sessionStorage.setItem('pulseWaitlistSubmittedForm', 'hero')
    this.storeNativeShopifySubscribeEmail()
    this.isSubmitting = true
    if (this.buttonLabel) {
      this.buttonLabel.textContent = 'Submitting'
    }
    this.submitButton.setAttribute('disabled', 'disabled')
    this.submitButton.style.cursor = 'not-allowed'
    this.submitButton.style.opacity = '0.7'

    clearTimeout(this.submitResetTimer)
    this.submitResetTimer = setTimeout(() => {
      this.resetSubmitState()
    }, 10000)
  }

  resetSubmitState() {
    this.isSubmitting = false
    clearTimeout(this.submitResetTimer)
    this.submitResetTimer = null

    if (this.buttonLabel && this.originalButtonLabel) {
      this.buttonLabel.textContent = this.originalButtonLabel
    }

    if (this.submitButton) {
      this.submitButton.removeAttribute('disabled')
      this.submitButton.style.removeProperty('cursor')
      this.submitButton.style.removeProperty('opacity')
    }
  }

  async handleKlaviyoFormSubmit(event, form) {
    event.preventDefault()

    if (!form || form.dataset.isSubmitting === 'true') return

    const emailInput = form.querySelector('input[type="email"]')
    const email = emailInput ? emailInput.value.trim() : ''
    this.clearFormMessage(form)

    if (!email || !this.isValidEmail(email)) {
      if (emailInput) {
        emailInput.setAttribute('aria-invalid', 'true')
        if (emailInput.reportValidity) emailInput.reportValidity()
      }
      this.showFormMessage(form, 'error', 'Please enter a valid email address.')
      return
    }

    const publicKey = form.dataset.klaviyoPublicKey
    const listId = form.dataset.klaviyoListId
    if (!publicKey || !listId) {
      this.showFormMessage(form, 'error', form.dataset.klaviyoError || 'Something went wrong. Please try again.')
      return
    }

    this.setFormSubmitting(form, true)

    try {
      const source = form.dataset.klaviyoSource || form.dataset.klaviyoForm || 'waitlist_form'
      const response = await this.submitKlaviyoSubscription({
        email,
        publicKey,
        listId,
        source
      })

      if (!response.ok) {
        const errorPayload = await this.readKlaviyoError(response)
        const isDuplicate = this.isDuplicateKlaviyoError(errorPayload)
        this.showFormMessage(
          form,
          isDuplicate ? 'success' : 'error',
          isDuplicate
            ? (form.dataset.klaviyoDuplicate || form.dataset.klaviyoSuccess || 'You are on the waitlist.')
            : (errorPayload || form.dataset.klaviyoError || 'Something went wrong. Please try again.')
        )

        if (isDuplicate) {
          this.handleKlaviyoSubscribeCheckoutRedirect(form, email)
        }
        return
      }

      emailInput.value = ''
      emailInput.removeAttribute('aria-invalid')
      this.showFormMessage(form, 'success', form.dataset.klaviyoSuccess || 'Thanks for joining the waitlist.')
      this.trackKlaviyoWaitlistEvent({ email, publicKey, source })
      this.handleKlaviyoSubscribeCheckoutRedirect(form, email)
    } catch (error) {
      this.showFormMessage(form, 'error', form.dataset.klaviyoError || 'Something went wrong. Please try again.')
    } finally {
      this.setFormSubmitting(form, false)
    }
  }

  async submitKlaviyoSubscription({ email, publicKey, listId, source }) {
    const signupDate = this.getLocalDateString()
    const endpoint = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                },
                properties: {
                  pulse_signup_source: source,
                  pulse_waitlist_campaign: 'super_early_bird',
                  pulse_waitlist_page: 'uahpet-pulse',
                  pulse_waitlist_signup_date: signupDate
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    }

    return this.fetchWithTimeout(endpoint, {
      method: 'POST',
      headers: this.getKlaviyoHeaders(),
      body: JSON.stringify(payload)
    }, 20000)
  }

  async trackKlaviyoWaitlistEvent({ email, publicKey, source }) {
    const endpoint = `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(publicKey)}`
    const payload = {
      data: {
        type: 'event',
        attributes: {
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: 'Pulse Waitlist Signup'
              }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          },
          properties: {
            source,
            page: 'uahpet-pulse',
            campaign: 'super_early_bird',
            signup_date: this.getLocalDateString()
          }
        }
      }
    }

    try {
      await this.fetchWithTimeout(endpoint, {
        method: 'POST',
        headers: this.getKlaviyoHeaders(),
        body: JSON.stringify(payload)
      }, 10000)
    } catch (error) {
      console.warn('Pulse waitlist event tracking failed', error)
    }
  }

  getSubscribeVariantId(form) {
    if (form && !this.contains(form)) return ''
    return this.dataset.subscribeVariantId || ''
  }

  getShopifyRootPath() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'
  }

  getSubscribeCheckoutUrl(variantId, email = '') {
    const rootPath = this.getShopifyRootPath()
    const normalizedRootPath = rootPath.endsWith('/') ? rootPath : `${rootPath}/`
    const emailParam = email ? `?checkout[email]=${encodeURIComponent(email)}` : ''

    return `${normalizedRootPath}cart/${encodeURIComponent(variantId)}:1${emailParam}`
  }

  getFormEmail(form = this.form) {
    const emailInput = form ? form.querySelector('input[type="email"]') : null
    return emailInput ? emailInput.value.trim() : ''
  }

  handleKlaviyoSubscribeCheckoutRedirect(form, email = '') {
    const variantId = this.getSubscribeVariantId(form)
    if (!variantId) return false
    window.location.href = this.getSubscribeCheckoutUrl(variantId, email || this.getFormEmail(form))
    return true
  }

  handleNativeShopifySubscribeCheckoutRedirect() {
    const successMessage = this.querySelector('[data-shopify-subscribe-success="true"]')
    const variantId = this.getSubscribeVariantId()
    if (!successMessage || !variantId) return false

    const storageKey = this.getNativeShopifySubscribeCheckoutStorageKey(successMessage, variantId)
    if (this.hasNativeShopifySubscribeCheckoutRedirect(storageKey)) return false

    this.markNativeShopifySubscribeCheckoutRedirect(storageKey)

    const email = this.getFormEmail(this.form) || this.getStoredNativeShopifySubscribeEmail()
    this.clearStoredNativeShopifySubscribeEmail()
    window.location.href = this.getSubscribeCheckoutUrl(variantId, email)

    return true
  }

  getNativeShopifySubscribeEmailStorageKey() {
    const formId = this.form && this.form.id ? this.form.id : (this.id || 'subscribe-countdown')
    return `native-shopify-subscribe-email:${window.location.pathname}:${formId}`
  }

  storeNativeShopifySubscribeEmail() {
    const email = this.getFormEmail(this.form)
    if (!email) return

    try {
      sessionStorage.setItem(this.getNativeShopifySubscribeEmailStorageKey(), email)
    } catch (error) {
      // Ignore storage errors. The success page can still read the email from the rendered form value.
    }
  }

  getStoredNativeShopifySubscribeEmail() {
    try {
      return sessionStorage.getItem(this.getNativeShopifySubscribeEmailStorageKey()) || ''
    } catch (error) {
      return ''
    }
  }

  clearStoredNativeShopifySubscribeEmail() {
    try {
      sessionStorage.removeItem(this.getNativeShopifySubscribeEmailStorageKey())
    } catch (error) {
      // Ignore storage errors.
    }
  }

  getNativeShopifySubscribeCheckoutStorageKey(successMessage, variantId) {
    return `native-shopify-subscribe-checkout:${window.location.pathname}:${successMessage.id || this.id || 'subscribe-countdown'}:${variantId}`
  }

  hasNativeShopifySubscribeCheckoutRedirect(storageKey) {
    try {
      return sessionStorage.getItem(storageKey) === 'true'
    } catch (error) {
      return false
    }
  }

  markNativeShopifySubscribeCheckoutRedirect(storageKey) {
    try {
      sessionStorage.setItem(storageKey, 'true')
    } catch (error) {
      // Ignore storage errors and continue with the checkout redirect flow.
    }
  }

  getKlaviyoHeaders() {
    return {
      accept: 'application/vnd.api+json',
      'content-type': 'application/vnd.api+json',
      revision: this.klaviyoRevision
    }
  }

  async fetchWithTimeout(url, options, timeout) {
    const controller = new AbortController()
    const timer = window.setTimeout(() => controller.abort(), timeout)
    try {
      return await fetch(url, {
        ...options,
        signal: controller.signal
      })
    } finally {
      window.clearTimeout(timer)
    }
  }

  async readKlaviyoError(response) {
    try {
      const payload = await response.json()
      const firstError = payload && payload.errors && payload.errors[0]
      return firstError ? (firstError.detail || firstError.title || '') : ''
    } catch (error) {
      return ''
    }
  }

  isDuplicateKlaviyoError(message) {
    if (!message) return false
    return /already|duplicate|previously|subscribed/i.test(message)
  }

  setFormSubmitting(form, isSubmitting) {
    if (!form) return
    form.dataset.isSubmitting = isSubmitting ? 'true' : 'false'

    const submitButton = form.querySelector('button[type="submit"]')
    const buttonLabel = submitButton ? submitButton.querySelector('span:not(.visually-hidden)') : null

    if (isSubmitting) {
      if (!form.dataset.originalButtonLabel && buttonLabel) {
        form.dataset.originalButtonLabel = buttonLabel.textContent
      }
      if (buttonLabel) {
        buttonLabel.textContent = 'Submitting'
      }
      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled')
        submitButton.setAttribute('aria-label', 'Submitting')
        submitButton.style.cursor = 'not-allowed'
        submitButton.style.opacity = '0.7'
      }
      return
    }

    if (buttonLabel && form.dataset.originalButtonLabel) {
      buttonLabel.textContent = form.dataset.originalButtonLabel
    }
    if (submitButton) {
      submitButton.removeAttribute('disabled')
      submitButton.setAttribute('aria-label', form.dataset.originalButtonLabel || 'Subscribe')
      submitButton.style.removeProperty('cursor')
      submitButton.style.removeProperty('opacity')
    }
  }

  clearFormMessage(form) {
    form.querySelectorAll('.pulse-klaviyo-message').forEach(message => message.remove())
  }

  showFormMessage(form, type, message) {
    const messageElement = document.createElement('small')
    const isSuccess = type === 'success'
    const fallbackClass = form.id === 'subscribe-with-image'
      ? 'subscribe-with-image__success-fallback'
      : 'subscribe-countdown__success-fallback'

    messageElement.className = `pulse-klaviyo-message form__message alert alert--${isSuccess ? 'success' : 'error'} alert--small ${isSuccess ? `info-box__subscribe-success ${fallbackClass} is-visible` : ''}`
    messageElement.innerHTML = `${this.getMessageIcon(isSuccess)}${message}`
    form.insertAdjacentElement('beforeend', messageElement)
  }

  getMessageIcon(isSuccess) {
    if (isSuccess) {
      return '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73 12.35 12.35 9.73 12.35 6.5C12.35 3.27 9.73 0.65 6.5 0.65C3.27 0.65 0.65 3.27 0.65 6.5C0.65 9.73 3.27 12.35 6.5 12.35Z" fill="currentColor"/><path d="M5.53 8.77L3.76 7L4.47 6.29L5.53 7.36L8.53 4.36L9.24 5.07L5.53 8.77Z" fill="white"/></svg>'
    }
    return '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.5" r="5.85" stroke="currentColor" stroke-width="1.3" fill="none"/><path d="M6.5 3.25v3.9M6.5 9.1v.65" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>'
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  getLocalDateString() {
    return new Date().toLocaleDateString('en-CA')
  }
}
customElements.define('subscribe-countdown-section', SubscribeCountdownSection);

class JxsBannerS1FeatureSlider extends HTMLElement {
  constructor() {
    super()

    if (this.querySelectorAll('.splide__slide').length == 0) {
      this.remove()
      return
    }

    this.splide = new Splide(this.querySelector('.splide'), {
      perPage: 1,
      pagination: false,
      arrows: false
    })
    this.splide.mount()

    this.leftArrow = this.querySelector('.arrow-left')
    this.rightArrow = this.querySelector('.arrow-right')

    this.updateArrowState()
    this.splide.on('move moved mounted refreshed resize', () => {
      this.updateArrowState()
    })

    this.leftArrow.addEventListener('click', () => {
      this.splide.go('<')
    })
    this.rightArrow.addEventListener('click', () => {
      this.splide.go('>')
    })
  }

  updateArrowState() {
    if (!this.splide || !this.leftArrow || !this.rightArrow) return

    const currentIndex = this.splide.index || 0
    const lastIndex = Math.max(0, this.splide.length - 1)

    this.leftArrow.classList.toggle('is-hidden', currentIndex <= 0)
    this.leftArrow.setAttribute('aria-hidden', currentIndex <= 0 ? 'true' : 'false')
    this.leftArrow.tabIndex = currentIndex <= 0 ? -1 : 0

    this.rightArrow.classList.toggle('is-hidden', currentIndex >= lastIndex)
    this.rightArrow.setAttribute('aria-hidden', currentIndex >= lastIndex ? 'true' : 'false')
    this.rightArrow.tabIndex = currentIndex >= lastIndex ? -1 : 0
  }
}
customElements.define('jxs-banner-s1-feature-slider', JxsBannerS1FeatureSlider);

class JxsBannerS1 extends HTMLElement {
  #timeline = null

  constructor() {
    super()
    this.initScrollAnimation()
  }

  connectedCallback() {
    if (this.introInitialized) return
    this.introInitialized = true
    this.initIntroReveal()
  }

  get content1() {
    return this.querySelector('.banner-s1__content--1')
  }

  get content2() {
    return this.querySelector('.banner-s1__content--2')
  }

  initIntroReveal() {
    this.setAttribute('data-intro-ready', 'true')

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion || !('IntersectionObserver' in window)) {
      this.setAttribute('data-intro-revealed', 'true')
      return
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        this.setAttribute('data-intro-revealed', 'true')
        observer.unobserve(this)
      })
    }, {
      threshold: 0.32,
      rootMargin: '0px 0px -12% 0px'
    })

    observer.observe(this)
  }

  initScrollAnimation() {
    if (!window.gsap || !window.ScrollTrigger) return

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (reduceMotion) {
      this.style.setProperty('--blur-amount', 1)
      this.style.setProperty('--overlay-amount', 1)
      this.style.setProperty('--content-1-opacity', 0)
      this.style.setProperty('--content-2-opacity', 1)
      this.style.setProperty('--content-2-y', '0px')
      this.style.setProperty('--feature-2-opacity', 1)
      this.style.setProperty('--feature-2-y', '0px')
      this.content2 && this.content2.setAttribute('data-active', 'true')
      return
    }

    const blurDistance = parseInt(this.dataset.blurDistance) || 300
    const totalScroll = Math.max(700, blurDistance + Math.round(window.innerHeight * 0.45))

    this.#timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: 'top 70%',
        end: '+=' + totalScroll,
        scrub: 0.55,
        onUpdate: (self) => {
          this.content2 && this.content2.setAttribute('data-active', self.progress > 0.48 ? 'true' : 'false')
        }
      }
    })

    this.#timeline.to(this, {
      '--blur-amount': 1,
      '--overlay-amount': 1,
      ease: 'none',
      duration: 0.38
    }, 0.18)

    this.#timeline.to(this, {
      '--content-1-opacity': 0,
      '--content-1-y': '-54px',
      ease: 'power2.out',
      duration: 0.25
    }, 0.32)

    this.#timeline.to(this, {
      '--content-2-opacity': 1,
      '--content-2-y': '0px',
      ease: 'power3.out',
      duration: 0.34
    }, 0.50)

    this.#timeline.to(this, {
      '--feature-2-opacity': 1,
      '--feature-2-y': '0px',
      ease: 'power3.out',
      duration: 0.30
    }, 0.64)

    this.#timeline.to({}, { duration: 0.18 })
  }
}
customElements.define('jxs-banner-s1', JxsBannerS1);

function initJxsBannerS1Stories() {
  const stories = document.querySelectorAll('.jxs-banner-s1[data-s1-story]')
  if (!stories.length) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  stories.forEach((story) => {
    if (story.dataset.s1StoryReady === 'true') return
    story.dataset.s1StoryReady = 'true'

    if (reduceMotion) {
      story.style.setProperty('--s1-progress', '1')
      return
    }

    let ticking = false

    const update = () => {
      const rect = story.getBoundingClientRect()
      const travel = Math.max(1, rect.height - window.innerHeight)
      const progress = Math.min(1, Math.max(0, -rect.top / travel))
      story.style.setProperty('--s1-progress', progress.toFixed(4))
      ticking = false
    }

    const requestUpdate = () => {
      if (ticking) return
      ticking = true
      window.requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', requestUpdate)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJxsBannerS1Stories)
} else {
  initJxsBannerS1Stories()
}

function initUahpetTextReveals() {
  const sections = document.querySelectorAll('[id$="__jxs_section_TWRMzk"]')
  if (!sections.length) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.setAttribute('data-uahpet-revealed', 'true'))
    return
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.setAttribute('data-uahpet-revealed', 'true')
      observer.unobserve(entry.target)
    })
  }, {
    threshold: 0.35,
    rootMargin: '0px 0px -12% 0px'
  })

  sections.forEach((section) => observer.observe(section))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUahpetTextReveals)
} else {
  initUahpetTextReveals()
}

function initUahpetSectionReveals(container = document) {
  const sectionSelector = '.jxs-banner-s3:not([data-section-reveal-initialized]), .jxs-banner-s4:not([data-section-reveal-initialized])'
  const sections = [
    ...(container.matches && container.matches(sectionSelector) ? [container] : []),
    ...container.querySelectorAll(sectionSelector)
  ]
  if (!sections.length) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.setAttribute('data-inview', 'true'))
    return
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.setAttribute('data-inview', 'true')
      observer.unobserve(entry.target)
    })
  }, {
    threshold: 0.38,
    rootMargin: '0px 0px -18% 0px'
  })

  sections.forEach((section) => {
    section.setAttribute('data-section-reveal-initialized', 'true')
    observer.observe(section)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUahpetSectionReveals)
} else {
  initUahpetSectionReveals()
}

class JxsBannerS2 extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (this.initialized) return
    this.initialized = true
    this.init()
    this.revealOnView()
  }

  revealOnView() {
    if (!window.Motion || !Motion.inView) {
      this.setAttribute('data-inview', 'true')
      this.playVideo(this.currentIndex || 0)
      return
    }

    let stop
    stop = Motion.inView(this, () => {
      this.setAttribute('data-inview', 'true')
      this.playVideo(this.currentIndex || 0)
      if (typeof stop === 'function') stop()
    }, { margin: '-12% 0px -12% 0px' })
  }

  get mediaContainer() {
    return this.querySelector('.banner-s2__media')
  }

  get tabList() {
    return this.querySelector('.banner-s2__tab-list')
  }

  get tabSlider() {
    return this.querySelector('.banner-s2__tab-slider')
  }

  init() {
    const blocks = Array.from(this.querySelectorAll('.banner-s2__block'))
    if (blocks.length === 0) return

    const splideList = this.tabSlider.querySelector('.splide__list')

    blocks.forEach((block, index) => {
      const video = block.querySelector('video')
      const titleEl = block.querySelector('.banner-s2__text-title')
      const descEl = block.querySelector('.banner-s2__text-desc')

      // 1. 视频放到 mediaContainer
      if (video) {
        video.dataset.index = index
        if (index === 0) video.setAttribute('active', '')
        this.mediaContainer.appendChild(video)
      }

      // 2. 创建 tab item 副本放到 tabList
      if (titleEl && descEl) {
        const tabItem = document.createElement('div')
        tabItem.classList.add('tab-item')
        tabItem.dataset.index = index
        if (index === 0) tabItem.setAttribute('active', '')
        tabItem.appendChild(titleEl.cloneNode(true))
        tabItem.appendChild(descEl.cloneNode(true))
        this.tabList.appendChild(tabItem)

        // 3. 创建 slide item 副本放到 tabSlider
        const slideItem = document.createElement('li')
        slideItem.classList.add('splide__slide')
        slideItem.dataset.index = index
        const slideInner = document.createElement('div')
        slideInner.classList.add('slide-item')
        slideInner.appendChild(titleEl.cloneNode(true))
        slideInner.appendChild(descEl.cloneNode(true))
        slideItem.appendChild(slideInner)
        splideList.appendChild(slideItem)
      }

      // 4. 删除原始block
      block.parentNode && block.parentNode.removeChild(block)
    })

    this.bindTabEvents()
    this.initSplide()
    this.updateTitleWidths()

    // 字体加载后再测量一次，避免字体未加载导致测量偏�?
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.updateTitleWidths())
    }
  }

  updateTitleWidths() {
    this.tabList.querySelectorAll('.tab-item').forEach(item => {
      const title = item.querySelector('.banner-s2__text-title')
      if (!title) return
      const w = title.getBoundingClientRect().width
      if (w > 0) {
        item.style.setProperty('--title-w', w + 'px')
      }
    })
  }

  bindTabEvents() {
    this.tabList.querySelectorAll('.tab-item').forEach(item => {
      item.addEventListener('click', () => {
        const index = parseInt(item.dataset.index)
        this.setActiveItem(index)
      })
    })
  }

  initSplide() {
    const splideEl = this.tabSlider.querySelector('.splide')
    if (!splideEl) return
    if (splideEl.querySelectorAll('.splide__slide').length === 0) return

    this.splide = new Splide(splideEl, {
      perPage: 1,
      pagination: false,
      arrows: false
    })
    this.splide.on('move', (newIndex) => {
      this.setActiveItem(newIndex, true)
    })
    this.splide.mount()

    this.leftArrow = this.tabSlider.querySelector('.arrow-left')
    this.rightArrow = this.tabSlider.querySelector('.arrow-right')
    this.updateSliderArrowState()
    this.splide.on('moved mounted refreshed resize', () => {
      this.updateSliderArrowState()
    })

    this.leftArrow && this.leftArrow.addEventListener('click', () => this.splide.go('<'))
    this.rightArrow && this.rightArrow.addEventListener('click', () => this.splide.go('>'))
  }

  updateSliderArrowState() {
    if (!this.splide || !this.leftArrow || !this.rightArrow) return

    const currentIndex = this.splide.index || 0
    const lastIndex = Math.max(0, this.splide.length - 1)

    this.leftArrow.classList.toggle('is-hidden', currentIndex <= 0)
    this.leftArrow.setAttribute('aria-hidden', currentIndex <= 0 ? 'true' : 'false')
    this.leftArrow.tabIndex = currentIndex <= 0 ? -1 : 0

    this.rightArrow.classList.toggle('is-hidden', currentIndex >= lastIndex)
    this.rightArrow.setAttribute('aria-hidden', currentIndex >= lastIndex ? 'true' : 'false')
    this.rightArrow.tabIndex = currentIndex >= lastIndex ? -1 : 0
  }

  setActiveItem(index, fromSlider = false) {
    this.currentIndex = index
    this.updateSliderArrowState()
    // 切换tabList激活项
    this.tabList.querySelectorAll('.tab-item').forEach(item => {
      if (parseInt(item.dataset.index) === index) {
        item.setAttribute('active', '')
      } else {
        item.removeAttribute('active')
      }
    })

    // 同步splide
    if (this.splide && !fromSlider) {
      this.splide.go(index)
    }

    // 切换视频
    this.playVideo(index)
  }

  playVideo(index) {
    const videos = this.mediaContainer.querySelectorAll('video')
    videos.forEach(video => {
      if (parseInt(video.dataset.index) === index) {
        video.setAttribute('active', '')
        try {
          video.pause()
          video.currentTime = 0
          const p = video.play()
          if (p && typeof p.catch === 'function') p.catch(() => {})
        } catch (e) {}
      } else {
        video.removeAttribute('active')
        try {
          video.pause()
          video.currentTime = 0
        } catch (e) {}
      }
    })
  }
}
customElements.define('jxs-banner-s2', JxsBannerS2);

/*
 * ============================================================================
 * JxsBannerS4 自定义元�?
 * ----------------------------------------------------------------------------
 * 背景：本 section 使用 Shopify 动�?block，每�?tab 是一�?_banner-s4-block�?
 *      内部包含【tab 标签】、【背景图 picture】、【数据卡�?grid】三类数据�?
 *      但页面真正需要的视觉结构是：
 *        .banner-s4__background           �?所�?tab 的背景图叠在这里，按 active 切换
 *        .banner-s4__tab-list             �?所�?tab 标签
 *        .banner-s4__data-grid-container  �?所�?tab 的数据卡�?grid 叠在这里
 *
 *      因此初始化时需要把每个 block 内部�?picture / data-grid "提取"出来�?
 *      搬到外层的统一容器，再通过 [active] 属性切换显示�?
 *
 * 设计要点�?
 *   - background-image 通过 opacity 切换（CSS 里设�?transition），有淡入淡�?
 *   - data-grid 通过 display: none/grid 切换（CSS �?[active] 显示�?
 *   - block 上的 CSS 变量�?-grid-cols / --col-gap / --row-gap）会被复制到
 *     搬出后的 data-grid 上，确保 grid 列模板和等比间距正确生效
 *     （等比间距细节见 jxs-banner-s4.css 顶部注释 �?_banner-s4-block.liquid�?
 * ============================================================================
 */
class JxsBannerS4 extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (this.initialized) return
    this.initialized = true
    this.init()
  }

get backgroundContainer() {
    return this.querySelector('.banner-s4__background')
  }

  get tabList() {
    return this.querySelector('.banner-s4__tab-list')
  }

  get dataGridContainer() {
    return this.querySelector('.banner-s4__data-grid-container')
  }

  init() {
    const blocks = Array.from(this.querySelectorAll('.banner-s4__block'))
    if (blocks.length === 0) return
    this.bindCarouselEvents()

    blocks.forEach((block, index) => {
      block.dataset.index = index
      block.removeAttribute('data-hot-scroll-initialized')
      block.removeAttribute('data-hot-scroll-reveal-item')
      block.removeAttribute('data-hot-scroll-revealed')
      block.style.removeProperty('--hot-scroll-opacity')
      block.style.removeProperty('--hot-scroll-y')
      block.style.removeProperty('--hot-scroll-delay')
      block.style.removeProperty('opacity')
      block.style.removeProperty('transform')
      block.style.removeProperty('transition')
      block.style.removeProperty('will-change')

      // 1. 将背景图(picture)�?block 内部搬到统一�?.banner-s4__background 容器
      //    多张背景图叠在一起，�?[active] 控制透明度切�?
      const bgPicture = block.querySelector('.responsive-picture')
      if (bgPicture) {
        bgPicture.dataset.index = index
        const bgImg = bgPicture.querySelector('.background-image')
        if (bgImg && index === 0) bgImg.setAttribute('active', '')
        this.backgroundContainer.appendChild(bgPicture)
      }

      // 2. 将数据卡�?grid �?block 内部搬到统一�?.banner-s4__data-grid-container
      //    block 上承载了 --grid-cols / --col-gap / --row-gap �?CSS 变量�?
      //    必须把这些变�?过户"到搬出后�?grid 上（block 那个壳只�?tab 标签�?
      const dataGrid = block.querySelector('.banner-s4__data-grid')
      if (dataGrid && this.dataGridContainer) {
        dataGrid.dataset.index = index
        const styleAttr = block.getAttribute('style')
        if (styleAttr) {
          dataGrid.setAttribute('style', styleAttr)
        }
        if (index === 0) dataGrid.setAttribute('active', '')
        this.dataGridContainer.appendChild(dataGrid)
      }

      // 3. 默认激活第一�?tab
      if (index === 0) block.setAttribute('active', '')

      // 4. 绑定 tab 点击事件，切换三处的 [active]：tab / background-image / data-grid
      block.addEventListener('click', () => {
        this.setActive(index)
      })
    })

    this.initCarousels()
  }

  bindCarouselEvents() {
    if (this.carouselEventsBound) return
    this.carouselEventsBound = true

    this.addEventListener('click', event => {
      const target = event.target
      if (!target || typeof target.closest !== 'function') return
      if (target.closest('.banner-s4__tab-list')) return

      const arrow = target.closest('.banner-s4-carousel__arrow')
      if (arrow && this.contains(arrow)) {
        const carousel = arrow.closest('[data-s4-carousel]')
        if (!carousel) return
        event.preventDefault()
        event.stopPropagation()
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation()
        }
        this.moveCarousel(carousel, arrow.classList.contains('banner-s4-carousel__arrow--prev') ? -1 : 1)
        return
      }

      const slide = target.closest('[data-s4-slide]')
      if (slide && this.contains(slide)) {
        const carousel = slide.closest('[data-s4-carousel]')
        const isClickableCarousel =
          carousel &&
          (carousel.classList.contains('banner-s4-carousel--ai') ||
            carousel.classList.contains('banner-s4-carousel--signals'))
        if (!isClickableCarousel) return
        event.preventDefault()
        event.stopPropagation()
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation()
        }
        if (carousel.dataset.s4SwipeSuppressClick === 'true') {
          carousel.dataset.s4SwipeSuppressClick = 'false'
          return
        }
        if (!slide.classList.contains('is-current')) {
          const slides = Array.from(carousel.querySelectorAll('[data-s4-slide]'))
          const slideIndex = slides.indexOf(slide)
          if (slideIndex >= 0) this.setCarouselActive(carousel, slideIndex)
        }
      }
    }, true)
  }

  initCarousels() {
    this.querySelectorAll('[data-s4-carousel]').forEach(carousel => {
      const isAiCarousel = carousel.classList.contains('banner-s4-carousel--ai')
      const isSignalsCarousel = carousel.classList.contains('banner-s4-carousel--signals')
      if (isAiCarousel || isSignalsCarousel) {
        this.bindMobileCarouselSwipe(carousel)
      }

      if (carousel.dataset.s4CarouselReady === 'true') return
      carousel.dataset.s4CarouselReady = 'true'
      carousel.dataset.currentIndex = '0'

      const prevButton = carousel.querySelector('.banner-s4-carousel__arrow--prev')
      const nextButton = carousel.querySelector('.banner-s4-carousel__arrow--next')

      if (prevButton) {
        prevButton.addEventListener('click', event => {
          event.preventDefault()
          event.stopPropagation()
          this.moveCarousel(carousel, -1)
        })
      }

      if (nextButton) {
        nextButton.addEventListener('click', event => {
          event.preventDefault()
          event.stopPropagation()
          this.moveCarousel(carousel, 1)
        })
      }

      if (isAiCarousel || isSignalsCarousel) {
        carousel.querySelectorAll('[data-s4-slide]').forEach((slide, slideIndex) => {
          slide.addEventListener('click', event => {
            event.stopPropagation()
            if (!slide.classList.contains('is-current')) {
              this.setCarouselActive(carousel, slideIndex)
            }
          })
        })
      }

      this.setCarouselActive(carousel, 0)
    })
  }

  bindMobileCarouselSwipe(carousel) {
    if (carousel.dataset.s4SwipeReady === 'true') return
    carousel.dataset.s4SwipeReady = 'true'

    const isSignalsCarousel = carousel.classList.contains('banner-s4-carousel--signals')
    let startX = 0
    let startY = 0
    let tracking = false
    let pointerId = null
    let mouseTracking = false
    const swipeThreshold = 22
    const swipeAxisRatio = 1.05

    carousel.querySelectorAll('img').forEach(image => {
      image.setAttribute('draggable', 'false')
    })

    const isTabControl = target => Boolean(
      target &&
      typeof target.closest === 'function' &&
      target.closest('.banner-s4__tab-list')
    )

    const isInsideRect = (rect, x, y) => {
      return x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom
    }

    const isInsideSwipeArea = (x, y) => {
      if (isSignalsCarousel) {
        const carouselRect = carousel.getBoundingClientRect()
        if (carouselRect.width > 0 && carouselRect.height > 0 && isInsideRect(carouselRect, x, y)) return true
      }

      const frame = carousel.querySelector('.banner-s4-carousel__frame')
      if (frame) {
        const frameRect = frame.getBoundingClientRect()
        if (frameRect.width > 0 && frameRect.height > 0 && isInsideRect(frameRect, x, y)) return true
      }

      const currentSlide = carousel.querySelector('[data-s4-slide].is-current')
      if (!currentSlide) return false

      return isInsideRect(currentSlide.getBoundingClientRect(), x, y)
    }

    const start = (x, y) => {
      startX = x
      startY = y
      tracking = true
    }

    const stop = () => {
      tracking = false
      pointerId = null
      mouseTracking = false
    }

    const commitSwipe = (x, y) => {
      if (!tracking) return false

      const deltaX = x - startX
      const deltaY = y - startY
      if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY) * swipeAxisRatio) return false

      stop()
      carousel.dataset.s4SwipeSuppressClick = 'true'
      this.moveCarousel(carousel, deltaX < 0 ? 1 : -1)
      return true
    }

    const finish = (x, y) => {
      if (!tracking) return
      if (commitSwipe(x, y)) return
      stop()
    }

    const ownerDocument = carousel.ownerDocument || document
    const ownerWindow = ownerDocument.defaultView || window
    const swipeTarget = carousel

    swipeTarget.addEventListener('mousedown', event => {
      if (event.button !== 0) return
      if (isTabControl(event.target)) return
      if (tracking) return
      if (!isInsideSwipeArea(event.clientX, event.clientY)) return

      event.preventDefault()
      mouseTracking = true
      start(event.clientX, event.clientY)
    }, true)

    ownerWindow.addEventListener('mousemove', event => {
      if (!mouseTracking) return
      if (Math.abs(event.clientX - startX) > 8) {
        event.preventDefault()
      }
      if (commitSwipe(event.clientX, event.clientY)) {
        mouseTracking = false
      }
    })

    ownerWindow.addEventListener('mouseup', event => {
      if (!mouseTracking) return

      finish(event.clientX, event.clientY)
    })

    if (window.PointerEvent) {
      swipeTarget.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return
        if (isTabControl(event.target)) return
        if (!isInsideSwipeArea(event.clientX, event.clientY)) return

        event.preventDefault()
        pointerId = event.pointerId
        if (carousel.setPointerCapture) {
          carousel.setPointerCapture(pointerId)
        }

        start(event.clientX, event.clientY)
      }, true)

      const handlePointerMove = event => {
        if (!tracking) return
        if (pointerId !== null && event.pointerId !== pointerId) return
        if (Math.abs(event.clientX - startX) > 8) {
          event.preventDefault()
        }
        if (commitSwipe(event.clientX, event.clientY)) {
          pointerId = null
        }
      }

      const handlePointerUp = event => {
        if (pointerId !== null && event.pointerId !== pointerId) return
        pointerId = null
        finish(event.clientX, event.clientY)
      }

      carousel.addEventListener('pointermove', handlePointerMove)
      ownerWindow.addEventListener('pointermove', handlePointerMove)
      carousel.addEventListener('pointerup', handlePointerUp)
      ownerWindow.addEventListener('pointerup', handlePointerUp)

      carousel.addEventListener('pointercancel', () => {
        stop()
      })
    }

    swipeTarget.addEventListener('touchstart', event => {
      if (isTabControl(event.target)) return
      if (tracking) return
      const touch = event.touches && event.touches[0]
      if (!touch) return
      if (!isInsideSwipeArea(touch.clientX, touch.clientY)) return

      start(touch.clientX, touch.clientY)
    }, { passive: true, capture: true })

    carousel.addEventListener('touchmove', event => {
      if (!tracking) return
      const touch = event.touches && event.touches[0]
      if (!touch) return
      if (Math.abs(touch.clientX - startX) > 8) {
        event.preventDefault()
      }
      commitSwipe(touch.clientX, touch.clientY)
    }, { passive: false })

    carousel.addEventListener('touchend', event => {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return

      finish(touch.clientX, touch.clientY)
    }, { passive: true })

    carousel.addEventListener('touchcancel', () => {
      stop()
    }, { passive: true })
  }

  moveCarousel(carousel, direction) {
    const currentIndex = parseInt(carousel.dataset.currentIndex || '0')
    this.setCarouselActive(carousel, currentIndex + direction)
  }

  setCarouselActive(carousel, index) {
    const slides = Array.from(carousel.querySelectorAll('[data-s4-slide]'))
    if (slides.length === 0) return

    const length = slides.length
    const current = ((index % length) + length) % length
    const previous = (current - 1 + length) % length
    const next = (current + 1) % length
    const isSignalsCarousel = carousel.classList.contains('banner-s4-carousel--signals')
    const signalSidePositions =
      isSignalsCarousel && length > 4
        ? [
            { index: next, className: 'is-side-left-far' },
            { index: (current + 2) % length, className: 'is-side-left-near' },
            { index: (current + 3) % length, className: 'is-side-right-near' },
            { index: (current + 4) % length, className: 'is-side-right-far' },
          ]
        : []

    carousel.dataset.currentIndex = current

    slides.forEach((slide, slideIndex) => {
      slide.classList.remove(
        'is-current',
        'is-prev',
        'is-next',
        'is-side-left-far',
        'is-side-left-near',
        'is-side-right-near',
        'is-side-right-far'
      )
      slide.setAttribute('aria-hidden', 'true')

      if (slideIndex === current) {
        slide.classList.add('is-current')
        slide.removeAttribute('aria-hidden')
      } else if (signalSidePositions.length > 0) {
        const signalSidePosition = signalSidePositions.find(position => position.index === slideIndex)
        if (signalSidePosition) {
          slide.classList.add(signalSidePosition.className)
        }
      } else if (slideIndex === previous) {
        slide.classList.add('is-prev')
      } else if (slideIndex === next) {
        slide.classList.add('is-next')
      }
    })
  }

  setActive(index) {
    // 切换 tab 激活状�?
    this.querySelectorAll('.banner-s4__block').forEach(b => {
      if (parseInt(b.dataset.index) === index) {
        b.setAttribute('active', '')
      } else {
        b.removeAttribute('active')
      }
    })

    // 切换背景图激活状�?
    this.backgroundContainer.querySelectorAll('.background-image').forEach(img => {
      const picture = img.closest('.responsive-picture')
      const idx = picture ? parseInt(picture.dataset.index) : NaN
      if (idx === index) {
        img.setAttribute('active', '')
      } else {
        img.removeAttribute('active')
      }
    })

    // 切换数据卡图 grid 激活状�?
    if (this.dataGridContainer) {
      this.dataGridContainer.querySelectorAll('.banner-s4__data-grid').forEach(grid => {
        if (parseInt(grid.dataset.index) === index) {
          grid.setAttribute('active', '')
          const carousel = grid.querySelector('[data-s4-carousel]')
          if (carousel) this.setCarouselActive(carousel, 0)
        } else {
          grid.removeAttribute('active')
        }
      })
    }
  }
}
customElements.define('jxs-banner-s4', JxsBannerS4);

/*
* ---------------------------------------------------------------
* 这个店铺莫名其妙会插入一�? && "符号，无法定位是哪个地方插入的，因此强制
* 删除这个神龙见首不见尾的符号�?
* ---------------------------------------------------------------
*/
let __times__ = 0
let __hasRemove = false
let __removeIntervalId = null
function __removeSignElement () {
  for ( const ch of document.body.childNodes) {
    if (typeof ch.nodeValue === 'string' && ch.nodeValue.length === 5 && ch.nodeValue.startsWith(' &&')) {
      document.body.removeChild(ch)
      __hasRemove = true
      if (console.log) {
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
        console.log('移除了元素，如果是误删除，请调整代码：critical-global.js')
        console.log('------------------------------------------------')
        console.log(ch)
        console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
      }
    }
  }
  if (__hasRemove || __times__++ > 6) {
    clearInterval(__removeIntervalId)
  }
}
__removeSignElement()
if (!__hasRemove) {
  __removeIntervalId = setInterval(__removeSignElement, 1000)
}
